import moment    from 'moment'
import BigNumber from 'bignumber.js'
import Model     from 'alto-orm/lib/orm/model'

class Transaction extends Model
  # attrs: clientID (fkey), billHeaderID (fkey, optional), kind (string), amount (decimal),
  # balance (decimal), transactedAt (moment), description (string), displayDescription (string)

  @nominativeName: 'transakce'
  @accusativeName: 'transakci'

  @attrNameMapping:
    clientID:     'client'
    billHeaderID: 'bill_header'

  @deserialize: (row) ->
    transaction = super(row)

    transaction.amount       = new BigNumber(row.amount)
    transaction.balance      = new BigNumber(row.balance)
    transaction.transactedAt = moment(row.transacted_at)

    transaction

  @serialize: (transaction) ->
    row = super(transaction)

    row.amount        = transaction.amount.toString()
    row.balance       = transaction.balance.toString()
    row.transacted_at = transaction.transactedAt.format() if transaction.transactedAt

    row

  @humanKinds = { POI: 'body', KC: 'peníze', UTR: 'peníze' }

  Object.defineProperty(@::, 'humanKind', get: -> @constructor.humanKinds[@kind])

export default Transaction
